import { UnderMaintenance } from '@components/ui';

export const UserDetails = () => {
    return <UnderMaintenance />;
};

UserDetails.displayName = 'UserDetails';
